import { DocumentSignatureStatus } from '@bulthaup/api/db';
import { Button, Group, Text, Title } from '@mantine/core';
import { IconEye } from '@tabler/icons-react';
import { sortBy } from 'lodash';

import { SignatureRequestStatusBadge } from '../../-components/-signature-request-status-badge';
import { RouterOutput } from '../../../../../../services/trpc';
import { getUTDocumentUrl } from '../../../../../../services/upload';

export function ConstructionSiteReportList({
  CSRDocuments,
}: {
  CSRDocuments: NonNullable<RouterOutput['projects']['get']>['documents'];
}) {
  const documents = CSRDocuments.filter(
    document => document.signatureStatus === DocumentSignatureStatus.DONE,
  );

  if (documents.length === 0) {
    return null;
  }

  return (
    <>
      <Title order={5}>PV signés</Title>
      {sortBy(documents, 'createdAt')
        .reverse()
        .map(document => (
          <Group
            key={document.id}
            align="center"
            style={{
              width: '100%',
              borderLeft: '1px solid ',
              paddingLeft: '10px',
            }}
          >
            <Text size="sm" truncate>
              {document.createdAt.toLocaleDateString('fr-FR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
              })}
            </Text>
            <SignatureRequestStatusBadge status={document.signatureStatus} />
            <Button
              leftSection={<IconEye size={16} />}
              variant="outline"
              onClick={() => {
                window.open(getUTDocumentUrl(document.utFileKey), '_blank');
              }}
            >
              Voir le Document
            </Button>
          </Group>
        ))}
    </>
  );
}
